// Tours booked on WhatsApp only (no online deposit)
export default {
  whatsappOnly: {
    badge: 'Reserva por WhatsApp',
    note: 'Este paseo se reserva directamente con nuestro equipo por WhatsApp. Confirmamos la disponibilidad y acordamos el pago contigo — sin pago anticipado en el sitio.',
    reserve: 'Reservar por WhatsApp',
    secure: 'Sin pago en el sitio: nuestro equipo confirma todo contigo por WhatsApp.',
    cartNote: 'Este pedido se confirma por WhatsApp: nuestro equipo verifica la disponibilidad y acuerda el pago contigo.',
    cartMixed: 'Tu carrito incluye paseos que solo se reservan por WhatsApp, así que todo el pedido se confirmará por allí.',
    stepConfirm: 'WhatsApp',
    formLead: 'Completa tus datos y enviaremos la reserva completa a nuestro equipo por WhatsApp.',
    submit: 'Confirmar reserva por WhatsApp',
    submitHint: 'WhatsApp se abre con el paseo, la fecha, los participantes y tus datos ya completados.',
  },
};
